<script lang="ts">
	import { getClassicWebUrl } from "../currentUser";

	const classicWebUrl = getClassicWebUrl();

	var s = document.createElement("script");
	s.setAttribute("async", "async");
	s.setAttribute("referrerPolicy", "unsafe-url");
	s.setAttribute("src", `${classicWebUrl}/app/visit?ref=${btoa(document.referrer)}`);
	document.head.appendChild(s);
</script>
